import { FC } from 'react';
import { ButtonProps, Button, styled } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

interface ExpandButtonProps extends ButtonProps {
    expand: boolean;
}

const StyledExpandButton = styled(({ expand, ...props }: ExpandButtonProps) => {
    return <Button {...props} />;
})(({ theme, expand }) => ({
    '& .MuiSvgIcon-root': {
        transform: expand ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
}));

const ExpandButton: FC<ExpandButtonProps> = (props) => {
    return <StyledExpandButton endIcon={<ExpandMoreIcon fontSize="small" />} {...props} />;
};

export type { ExpandButtonProps };
export default ExpandButton;
